import * as React from 'react';
import { IconBullet16 } from '@cian/ui-kit/icons';
import { UIText1 } from '@cian/ui-kit/typography';

import { ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES, INFRASTRUCTURE_MAP_ICON_MAP } from '../../../../constants/infrastructure';
import { IRegularInfrastructureType, TRegularInfrastructureType } from '../../../../types/map';
import { ItemsCarousel } from '../../../ItemsCarousel';
import { VerticalSmallArrow } from '../../../VerticalSmallArrow';
import * as styles from './styles.css';

export interface IInfrastructureMapTypesProps {
  currentTypes: string[];
  onTypesChange: (types: string[]) => void;
  types: IRegularInfrastructureType[];
  futureTypes?: TRegularInfrastructureType[];
}

export const InfrastructureMapTypes: React.FC<IInfrastructureMapTypesProps> = ({
  currentTypes,
  onTypesChange,
  types,
  futureTypes = [],
}) => {
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const type = event.currentTarget.getAttribute('data-type') as string;
      onTypesChange([...ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES, type]);
    },
    [onTypesChange],
  );

  return (
    <ItemsCarousel arrowButton={VerticalSmallArrow} scrollVisible>
      {types.map(({ title, type }) => {
        const checked = currentTypes.includes(type);
        const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);
        const hasNewData = futureTypes.includes(type);

        if (!Icon) {
          return null;
        }

        return (
          <React.Fragment key={type}>
            <input
              type="radio"
              name={'infrastructureMapTypes'}
              checked={checked}
              onChange={handleChange}
              className={styles['input']}
              id={`infrastructure-map_${type}`}
              data-type={type}
            />
            <label
              aria-label={title}
              htmlFor={`infrastructure-map_${type}`}
              className={styles['label']}
              data-testid={`InfrastructureMapTypes-${type}${hasNewData ? '-hasNewData' : ''}`}
            >
              <span className={styles['icon']}>
                <Icon color={'gray_icons_100'} />
              </span>
              <UIText1>{title}</UIText1>
              {hasNewData && (
                <div className={styles['future-type-icon']}>
                  <IconBullet16 color="success_100" />
                </div>
              )}
            </label>
          </React.Fragment>
        );
      })}
    </ItemsCarousel>
  );
};
